"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Imperfections = exports.Qualities = exports.biasTapeType = exports.Material = exports.KnownOrEstimated = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["By Meter"] = "By Meter";
    SellingUnit["Bundle"] = "Bundle";
    SellingUnit["Roll"] = "Roll";
    SellingUnit["Package"] = "Package";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var KnownOrEstimated;
(function (KnownOrEstimated) {
    KnownOrEstimated["Known"] = "Known";
    KnownOrEstimated["Estimated"] = "Estimated";
})(KnownOrEstimated = exports.KnownOrEstimated || (exports.KnownOrEstimated = {}));
var Material;
(function (Material) {
    Material["Knit"] = "Knit";
    Material["Woven"] = "Woven";
})(Material = exports.Material || (exports.Material = {}));
var biasTapeType;
(function (biasTapeType) {
    biasTapeType["Single Fold"] = "Single Fold";
    biasTapeType["Continuous"] = "Continuous";
    biasTapeType["Blanket"] = "Blanket";
    biasTapeType["Double Fold"] = "Double Fold";
    biasTapeType["Fusible"] = "Fusible";
})(biasTapeType = exports.biasTapeType || (exports.biasTapeType = {}));
var Qualities;
(function (Qualities) {
    Qualities["Waterproofing"] = "Waterproofing";
    Qualities["Patterned"] = "Patterned";
    Qualities["Extra Wide"] = "Extra Wide";
})(Qualities = exports.Qualities || (exports.Qualities = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Marks"] = "Marks";
    Imperfections["Dusty"] = "Dusty";
    Imperfections["Discoloured"] = "Discoloured";
    Imperfections["Partially Unrolled"] = "Partially Unrolled";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
//# sourceMappingURL=biasTapeAttributes.js.map